import { render, staticRenderFns } from "./ProductDetails.vue?vue&type=template&id=f830a864&scoped=true&"
import script from "./ProductDetails.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ProductDetails.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ProductDetails.vue?vue&type=style&index=0&id=f830a864&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f830a864",
  null
  
)

export default component.exports